import { render, staticRenderFns } from "./mediaResultsDataComponent.vue?vue&type=template&id=52fab047"
import script from "./mediaResultsDataComponent.vue?vue&type=script&lang=js"
export * from "./mediaResultsDataComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports